import { gql } from '@apollo/client';

export const statusQuery = gql`
  query statusApi {
    status @rest(type: "Status", path: "", endpoint: "endpointstatus") {
      availableService
      message
      messageHome
    }
  }
`;
